/**
 * @generated SignedSource<<119a10cbc0da87c3eb2cbb8ae07a5470>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecentlyViewedDashboardBlockContentPaginationFragment$data = {
  readonly id: string;
  readonly recentlyViewedContentUsages: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "ContentUsage";
        readonly id: string;
        readonly product: {
          readonly slug: string;
        } | null;
        readonly viewerLastContentView: {
          readonly eventDatetime: string;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"ContentUsageGridItemFragment">;
      };
    }>;
    readonly totalCount: number;
  };
  readonly recentlyViewedOccurrences: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "Occurrence";
        readonly id: string;
        readonly product: {
          readonly slug: string;
        };
        readonly recording: {
          readonly mediaAssetUsage: {
            readonly viewerAssetVideoProgress: {
              readonly updatedAt: string;
            } | null;
          } | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"OccurrenceListItemFragment">;
      };
    }>;
    readonly totalCount: number;
  };
  readonly " $fragmentType": "RecentlyViewedDashboardBlockContentPaginationFragment";
};
export type RecentlyViewedDashboardBlockContentPaginationFragment$key = {
  readonly " $data"?: RecentlyViewedDashboardBlockContentPaginationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecentlyViewedDashboardBlockContentPaginationFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "recentlyViewedContentUsages"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./RecentlyViewedDashboardBlockContentPaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "RecentlyViewedDashboardBlockContentPaginationFragment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "recentlyViewedContentUsages",
      "args": null,
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "__RecentlyViewedDashboardBlockContent__recentlyViewedContentUsages_connection",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v1/*: any*/),
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ReportingContentView",
                  "kind": "LinkedField",
                  "name": "viewerLastContentView",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventDatetime",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ContentUsageGridItemFragment"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfoObjectType",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "concreteType": "OccurrenceNodeConnection",
      "kind": "LinkedField",
      "name": "recentlyViewedOccurrences",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "OccurrenceNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Occurrence",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v1/*: any*/),
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OccurrenceMedia",
                  "kind": "LinkedField",
                  "name": "recording",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AssetUsage",
                      "kind": "LinkedField",
                      "name": "mediaAssetUsage",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AssetVideoProgress",
                          "kind": "LinkedField",
                          "name": "viewerAssetVideoProgress",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "updatedAt",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "OccurrenceListItemFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "RecentlyViewedDashboardBlock",
  "abstractKey": null
};
})();

(node as any).hash = "48240e0c6701cb36169d8d36dec79f8b";

export default node;
